/**
 * Client-side Cal email checks. Non-berkeley.edu allowlist lives only on the server — see Cloud Function
 * `checkCalSignupEmail` / `checkCalAccessForSignedInAccount` and functions/berkeleyEmailAccess.js.
 */

/** True for @berkeley.edu (trimmed, case-insensitive). */
export function isBerkeleyEduEmail(rawEmail) {
  if (!rawEmail || typeof rawEmail !== 'string') return false;
  return rawEmail.trim().toLowerCase().endsWith('@berkeley.edu');
}

/** True for any *@*.edu address (trimmed, case-insensitive). */
export function isEduEmail(rawEmail) {
  if (!rawEmail || typeof rawEmail !== 'string') return false;
  return /\.edu$/i.test(rawEmail.trim());
}

/** Refer-a-friend email fields — any valid address (not restricted to berkeley.edu). */
export function referFriendEmailValidationError(raw) {
  const email = String(raw || '').trim().toLowerCase();
  if (!email) return 'Please enter an email.';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return 'Please enter a valid email address.';
  }
  return '';
}
